import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { MonitoredChannel } from '../api/models/monitored-channel';
import { MasterSearchParams } from './monitoredchannels-list.component';

/**
 * Data source for the MonitoredChannelList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class MasterMonitoredChannelsListDataSource implements DataSource<MonitoredChannel> {

  private monitoredChannelsSubject = new BehaviorSubject<MonitoredChannel[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private monitoredChannelsCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.monitoredChannelsCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<MonitoredChannel[]> {
    return this.monitoredChannelsSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.monitoredChannelsSubject.complete();
    this.loadingSubject.complete();
  }

  loadMonitoredChannels(params: MasterSearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve onpremise servers */
    this.retrieveService.getMastersMonitoredChannelsList(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(contents => {
      // console.log(contents);
      this.monitoredChannelsSubject.next(contents);
    });

    /* Count onpremise servers */
    this.retrieveService.getNumMasterMonitoredChannels(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.monitoredChannelsCount.next(count as number);
    });
  }
}

